import { colours } from "@shared/ui.design-system"
import { CloseIcon, TickIcon } from "@shared/ui.icons"
import { MarkdownContainer } from "@shared/ui.primitives"
import React from "react"

import {
  conIcon,
  conText,
  container,
  divider,
  icon,
  itemRow,
  proIcon,
  proText,
  section,
  title,
} from "./ProsAndConsList.css"

export interface ProsAndConsListProps {
  heading: string
  pros: string[]
  cons: string[]
}

export const ProsAndConsList: React.FC<ProsAndConsListProps> = ({
  heading,
  pros,
  cons,
}) => (
  <div className={container}>
    <div className={title}>{heading}</div>
    {pros.length ? <hr className={divider} /> : <></>}
    <div className={section}>
      {pros.map((pro, idx) => (
        <div className={itemRow} key={`pro-${idx}`}>
          <span className={`${icon} ${proIcon}`}>
            <TickIcon fill={colours.secondary.light} width={24} height={24} />
          </span>
          <span className={proText}>{<MarkdownContainer content={pro} />}</span>
        </div>
      ))}
    </div>
    {cons.length ? <hr className={divider} /> : <></>}
    <div className={section}>
      {cons.map((con, idx) => (
        <div className={itemRow} key={`con-${idx}`}>
          <span className={`${icon} ${conIcon}`}>
            <CloseIcon fill={colours.secondary.light} width={24} height={24} />
          </span>
          <span className={conText}>
            <MarkdownContainer content={con} />
          </span>
        </div>
      ))}
    </div>
  </div>
)
